import { useAppContext } from "ContextProvider/ContextProvider";
import Sidebar from "Layout/Sidebar/Sidebar";
import { Outlet } from "react-router-dom";

const SidebarLayout = ({setIsLoggedIn, isLoggedIn, userData, setUserData, aiCharacters}) => {
  const { leftSidebar, setLeftSidebar } = useAppContext();
  return (
    <>
      <Sidebar aiCharacters={aiCharacters} userData={userData} sidebar={leftSidebar} setSidebar={setLeftSidebar} isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} setUserData={setUserData} />
      <Outlet />
    </>
  );
};
export default SidebarLayout;
